import React, { useState, useEffect } from "react";
import TextField from "@mui/material/TextField";
import Select from "@mui/material/Select";
import MenuItem from "@mui/material/MenuItem";
import InputAdornment from "@mui/material/InputAdornment";
import { CountriesCode } from "./CountriesCode";

const MobileNumberFieldWithCountryCode = ({
  value,
  onChange,
  onBlur,
  onCountryCodeChange,
  label = "Mobile Number",
  placeholder = "Enter mobile number",
  variant = "standard",
  error = false,
  helperText = "",
  disabled = false,
  required = false,
  fullWidth = true,
  defaultValue = "",
  inputRef = null,
  className = "",
  sx = {},
  defaultCountryCode = "+91",
  ...otherProps
}) => {
  const [isdCode, setIsdCode] = useState(
    defaultCountryCode ? defaultCountryCode.replace("+", "") : "91"
  );
  const [filter, setFilter] = useState("");
  const [open, setOpen] = useState(false);

  // Update isdCode if defaultCountryCode changes
  useEffect(() => {
    if (defaultCountryCode) {
      const codeWithoutPlus = defaultCountryCode.replace("+", "");
      if (codeWithoutPlus !== isdCode) {
        setIsdCode(codeWithoutPlus);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultCountryCode]);

  const handleFilterChange = (event) => {
    setFilter(event.target.value);
  };

  const filteredCountries = CountriesCode.filter(
    (country) =>
      country.name.toLowerCase().includes(filter.toLowerCase()) ||
      country.isdCode.includes(filter)
  );

  const handleCountryCodeChange = (event) => {
    const newCode = event.target.value;
    setIsdCode(newCode);
    if (onCountryCodeChange) {
      onCountryCodeChange(newCode);
    }
  };

  const selectedCountry = CountriesCode.find(
    (country) => country.isdCode === isdCode
  );

  // Support both controlled and uncontrolled modes
  const textFieldProps = {
    className,
    onChange,
    onBlur,
    error,
    helperText,
    disabled,
    required,
    fullWidth,
    inputRef,
    label,
    placeholder,
    variant,
    autoComplete: "off",
    sx,
  };

  // Use value for controlled, defaultValue for uncontrolled
  if (value !== undefined && value !== null) {
    textFieldProps.value = value;
  } else if (defaultValue !== undefined && defaultValue !== "") {
    textFieldProps.defaultValue = defaultValue;
  }

  return (
    <TextField
      {...textFieldProps}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <Select
              id="isd-code-select"
              className="country-code-select"
              value={isdCode}
              onChange={handleCountryCodeChange}
              variant="standard"
              open={open}
              onOpen={() => setOpen(true)}
              onClose={() => {
                setOpen(false);
                setFilter(""); // Reset filter on close
              }}
              renderValue={() => (
                <div style={{ display: "flex", alignItems: "center" }}>
                  {selectedCountry && (
                    <img
                      src={selectedCountry.flag}
                      alt="flag"
                      style={{
                        width: "20px",
                        marginRight: "8px",
                      }}
                    />
                  )}
                  <span>+{isdCode}</span>
                </div>
              )}
              displayEmpty
              style={{ width: "100px" }}
            >
              <MenuItem disabled>
                <TextField
                  value={filter}
                  onChange={handleFilterChange}
                  placeholder="Search"
                  variant="standard"
                  fullWidth
                  InputProps={{ disableUnderline: true }}
                  autoFocus
                />
              </MenuItem>
              {filteredCountries.map((country) => (
                <MenuItem key={country.code} value={country.isdCode}>
                  <img
                    src={country.flag}
                    alt={country.name}
                    style={{
                      width: "20px",
                      marginRight: "8px",
                    }}
                  />
                  <span>
                    {country.name} (+{country.isdCode})
                  </span>
                </MenuItem>
              ))}
            </Select>
          </InputAdornment>
        ),
      }}
      {...otherProps}
    />
  );
};

export default MobileNumberFieldWithCountryCode;
